// extracted by mini-css-extract-plugin
export default {"mainFormCollapseButton":"mainFormCollapseButton---LLSdZ","queryBuilderButton":"queryBuilderButton---j2bsi"};